import React from "react";
import MultiSelect from "../../Components/MultiSelect";
import SingleSlider from "./SingleSlider";
import NewSkillFinder from "../../Components/NewSkillFinder";

const DesktopStep2 = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <React.Fragment>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("language")}
        </h1>
        <MultiSelect
          Options={props.Languages}
          Placeholder={translateText("select_languages")}
          Id="language"
          SaveSelectedItems={(SelectedLangs) =>
            props.SaveSelectedLangs(SelectedLangs)
          }
        />
      </section>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("location")}
        </h1>
        <MultiSelect
          Options={props.Locations}
          Placeholder={translateText("select_locations")}
          Id="location"
          SaveSelectedItems={(SelectedLocations) =>
            props.SaveSelectedLocations(SelectedLocations)
          }
        />
      </section>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("education")}
        </h1>
        <MultiSelect
          Options={props.EducationOptions}
          Placeholder={translateText("select_educations")}
          Id="education"
          SaveSelectedItems={(SelectedEducations) =>
            props.SaveSelectedEducation(SelectedEducations)
          }
        />
      </section>
      <section className="step-row">
        <h1 className="row-title">
          YoE<p className="mandatory">*</p>
        </h1>
        <SingleSlider Default={1} />
      </section>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("top_5_skills")}
          <p className="mandatory">*</p>
        </h1>
          <NewSkillFinder
              translateText={(Label) => translateText(Label)}
              Placeholder={translateText('search_for_skills')}
              MinCharsText={translateText('enter_2_characters_at_least')}
              NoResultText={translateText('no_results_found')}
              SelectedSkills={props.SelectedSkills}
              OnSelectSkill={(skill) => props.SaveSkill(skill)}
              OnRemoveSKill={(skill) => props.RemoveSkill(skill)}
          />
      </section>
    </React.Fragment>
  );
};

export default DesktopStep2;
